import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { selectors as authSelectors } from 'src/features/auth/authSlice';
import { useAppDispatch } from 'src/store';
import { Status as StatusTypes } from 'src/ts/enums';
import { selectors } from '../applicationTrackingSlice';
import { getApplicationTrackingAccessThunk } from '../services';

export const useApplicationTrackingAccess = () => {
  const dispatch = useAppDispatch();
  const user = useSelector(authSelectors.user);
  const status = useSelector(selectors.status);
  const allowed = useSelector(selectors.allowed);

  useEffect(() => {
    if (user?.id && status === StatusTypes.IDLE) {
      dispatch(getApplicationTrackingAccessThunk());
    }
  }, [user?.id, status, dispatch]);

  return {
    hasAccess: status === StatusTypes.SUCCESS && allowed,
    isLoading: status === StatusTypes.IDLE || status === StatusTypes.LOADING,
    isError: status === StatusTypes.ERROR
  };
};
